export default __webpack_public_path__ + "static/media/loginEntryPointFavorite.9b9b00c1.webp";